import { z } from "zod";

/**
 * The editable fragments of the yeet agent's system prompt, stored in a
 * prompt_bundles row and delivered to the sandbox through the MCP briefing
 * (get_page_context). Assembly — the multimodal branch selection and the join —
 * stays in worker code (workers/yeet/agent/prompt.ts renderYeetSystemPrompt);
 * only the text lives here so a non-technical editor can reword it without a
 * deploy. The two `investigate` variants are both stored because the agent
 * picks one at run time from the resolved model's multimodality.
 */
export const YeetAgentPromptDocumentSchema = z
  .object({
    protocolVersion: z.literal("evidence-v1"),
    persona: z.string().min(1),
    interconnected: z.string().min(1),
    protocolIntro: z.string().min(1),
    investigateMultimodal: z.string().min(1),
    investigateTextOnly: z.string().min(1),
    steps: z.array(z.string().min(1)).min(1),
    toolErrorsNote: z.string().min(1),
  })
  .strict();
export type YeetAgentPromptDocument = z.infer<
  typeof YeetAgentPromptDocumentSchema
>;
